import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import FlexibleTable, { TableData } from '../components/FlexibleTable';
import PageContainer from '../components/containers/PageContainer';
import Button from '../components/Button';
import { useAppDispatch, useAppSelector } from '../hooks';
import { getAcqTables, getTables, setCurrentProject } from '../features/Aggregate/AggregateSlice';
import SelectProject from '../components/Forms/SelectDataviewProject';
import OpenButton from '../components/popup_components/OpenButton';
import { fetchUsedProjects } from '../features/Project/ProjectSlice';
import IprojectData from '../interfaces/projectData.interface';
import AddNote from '../components/Forms/AddNote';
import { useLocalStorageState } from 'hooks/useLocalStorageState';
import axios from 'axios';
import Export from 'components/Forms/Export';
import { usePopup } from 'context/PopupContext';
import { closePopup } from 'utils/popupUtilities';


export default function Dataview() {
  const dispatch = useAppDispatch();

  const tableData = useAppSelector(state => state.Aggregate.tableData);
  const acqTableData = useAppSelector(state => state.Aggregate.acqTableData);
  const current_project = useAppSelector(state => state.Projects.current_project);
  const [selected, setSelected] = useState(current_project);
  const [hours, setHours] = useLocalStorageState<number>(
    "showLastHours",
    3
  );
  const hasRun = useRef(false);
  const { setPopupContent, openPopup } = usePopup();
  useEffect(() => {
    if(selected){
      dispatch(setCurrentProject(selected?.id))
      closePopup();
    }
    if(!selected){
      setPopupContent(<SelectProject onSubmit={onSelect}/>);
      openPopup();
    }
    dispatch(getTables({ project: selected?.id.toString(), hours }));
    dispatch(getAcqTables({ project: selected?.id.toString(), hours }));
  }, [selected]);

  useEffect(() => {
    dispatch(fetchUsedProjects())
    
    dispatch({ type: 'ssestream/connect', payload: "projects/getAggregated" })
  }, []);


  useEffect(() => {
    if (!hasRun.current && current_project != null) {
      setSelected(current_project);
      
      hasRun.current = true;
    }
  }, [current_project]);

  const onSelect = (project: IprojectData) => {
    setSelected(project);
  };

  const refetch = () => {
    dispatch(getTables({ project: selected?.id.toString(), hours }));
    dispatch(getAcqTables({ project: selected?.id.toString(), hours }));
  }



  return (
    <>
      <Navbar />
      <PageContainer title={selected ? selected.name : "Dataview"}>
        {selected !== undefined ?
          <div className="dataview flex flex-col gap-1">
            <OpenButton
              text='Select other project'
              styleClasses='width-full'
              newContent={<SelectProject onSubmit={onSelect} />} 
            />
            <OpenButton
              text='Add Note'
              styleClasses='width-full'
              newContent={<AddNote />} 
            />
            <OpenButton
              text='Export'
              styleClasses='width-full'
              newContent={<Export project={selected} context={"summary"} />} 
            />
            <FlexibleTable title='Event Summary' data={tableData} sticky={true} amount={3} />
            <div className='flex justify-between items-center'>
              <h3 className="font-bold text-2xl dark:text-black">Acquisition</h3>
              <div className='flex justify-between items-center gap-1 w-1/2'>
                <p>Show last: </p>
                <input
                  type="number"
                  value={hours}
                  onChange={(e) => setHours(Number(e.target.value))}
                />
                <label> hours </label>
                <Button label='Show data' width='full ' onClick={refetch} />
                <OpenButton
                  text='Export'
                  styleClasses='width-full'
                  newContent={<Export project={selected} context={"acq"}/>}
                />
                {/* <Button label='Graph' width='full' /> */}
              </div>
            </div>
            <FlexibleTable data={acqTableData} sticky={true} amount={3} />
          </div>
          :
          <div></div>
        }
      </PageContainer>
    </>
  );
}